// import useSiteConfigAuth from "@/api/sanity/queries/getSiteConfigWithCode";
import { useUIStateStore } from "@/store/uiStateStore";

function SideNavLayout({ menu, children }) {
  // const { data: siteConfig } = useSiteConfigAuth();
  const isTunecore = useUIStateStore(state => state.isTunecore);
  return (
    <div className="flex flex-wrap overflow-auto xl:flex-nowrap">
      <div className={`grid flex-none w-full grid-cols-2 xl:w-52 ${isTunecore ? "max-lg:border-b-2 border-r-2 border-tunecore-dark-element" : "bg-sentric-mid-grey"} xl:gap-0 xl:block`}>{menu}</div>
      <div className="flex flex-grow min-w-0 m-2 max-md:px-2 max-md:py-8 sm:m-6 md:mx-12 md:my-12">
        {children}
      </div>
    </div>
  );
}

export default SideNavLayout;
